<template>
    <div class="modal" v-if="active">
        <div class="modal-content">
            Share the things
        </div>
    </div>
</template>

<script>
    import router from '../router.js';
    import EventBus from '../eventbus.js';

    export default {
        props : [
            'driver'
        ],
        data : function() {
            return {
                active: false,
            }
        },
        created() {
            EventBus.$on( 'sharePopup', (data) => {
                this.active = true;
            });
        },
        mounted() {
        },
        methods : {
        },
    }
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/SharePopup.vue